"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _avatar = _interopRequireDefault(require("antd/lib/avatar"));

var _button = _interopRequireDefault(require("antd/lib/button"));

var _dropdown = _interopRequireDefault(require("antd/lib/dropdown"));

var _layout = _interopRequireDefault(require("antd/lib/layout"));

var _menu = _interopRequireDefault(require("antd/lib/menu"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");

var _AntdIcon = _interopRequireDefault(require("../antdIcon/AntdIcon"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _sidebar = require("../../redux/sidebar/sidebar.types");

var _app = require("../../redux/app/app.types");

var _SideBarToggleButton = _interopRequireDefault(require("../sidebar/SideBarToggleButton"));

require("./header.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class Header extends _react.Component {
  constructor() {
    super(...arguments);

    this.handleLogout = event => {
      event.stopPropagation();
      this.props.logout();
    };

    this.handleToggleButtonClick = () => {
      const {
        toggleCallback
      } = this.props;
      toggleCallback();
    };
  }

  render() {
    const {
      Header: AntdHeader
    } = _layout.default;
    const {
      children,
      collapsed,
      user = {
        firstName: ''
      }
    } = this.props;

    const userMenu = /*#__PURE__*/_react.default.createElement(_menu.default, null, /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "logout"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "logout-btn",
      type: "link",
      onClick: this.handleLogout
    }, /*#__PURE__*/_react.default.createElement("span", null, "Logout"))));

    return /*#__PURE__*/_react.default.createElement(AntdHeader, {
      id: "header"
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: "header-left"
    }, /*#__PURE__*/_react.default.createElement(_SideBarToggleButton.default, {
      collapsed: collapsed,
      toggleCallback: this.handleToggleButtonClick
    }), children), /*#__PURE__*/_react.default.createElement("div", {
      id: "header-right"
    }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_avatar.default, {
      size: "small",
      icon: /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        fontAwesomeIcon: _proSolidSvgIcons.faUser
      })
    })), /*#__PURE__*/_react.default.createElement(_dropdown.default, {
      overlay: userMenu,
      trigger: ['click']
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "ant-dropdown-link",
      onClick: e => e.preventDefault()
    }, user.firstName, ' ', /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
      fontAwesomeIcon: _proSolidSvgIcons.faChevronDown
    })))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  collapsed: selectors.isSidebarCollapsed,
  user: selectors.getUser
});

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch((0, _app.logout)()),
    toggleCallback: () => dispatch((0, _sidebar.toggleSideBar)())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header);

exports.default = _default;